<div class="access-denied-container ">
  <div class="content-wrapper">
    <!-- Header Section -->
    <div class="header-section">
      <div class="logo-container">
        <img src="../assets/img/ST-logo.svg" alt="logo" class="logo">
      </div>
    </div>

    <!-- Error Message Section -->
    <div class="error-message-section d-flex flex-column gap-32 align-items-center">
      <div class="d-flex flex-column gap-8 align-items-center">
          <div class="error-icon-container d-flex  gap-8">
            <snl-icon [iconType]="'svg'" icon="../assets/icon/WarningCircle.svg"></snl-icon>
            <span class="heading-text">Access required</span>
          </div>
          <p class="body-b1 color__primary">It looks like your account does not have access to Crew Self Service yet. Contact your admin to gain access.</p>
      </div>

      <div class="content-container d-flex flex-column gap-32 align-items-center">
          <div class="content-item">
              <div class="action-buttons">
                <snl-button 
                  type="primary" 
                  size="large" 
                  (buttonClick)="signIn()"
                  class="primary-button">
                  Log in using another account
                </snl-button>
                
                <a href="#" class="section-title color__primary_default"  (click)="openFeedback($event)"> You can also provide additional feedback (optional)</a>
              </div>
          </div>
          <div class="content-item">
            <div class="image-section">
              <img src="../assets/img/access-denied-bg.png" alt="access-denied" class="illustration-image">
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
